import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  SplitTextField,
  TextField,
  Typography,
} from "@suraasa/placebo-ui"
import { useMutation } from "@tanstack/react-query"
import clsx from "clsx"
import { AnimatePresence, motion } from "framer-motion"
import { useEffect } from "react"
import { Controller, useForm } from "react-hook-form"

import { API } from "@/api"
import countryCodes from "@/lib/country-codes"
import { buildPhoneNumber } from "@/lib/hooks/build-phone-number"
import { useClubId } from "@/lib/hooks/use-club-id"
import { mapErrors } from "@/lib/map-errors"

import SuccessFormSubmit from "./success-form-submit"

const transitionVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
}

// type SelectOptionType = {
//   label: string
//   value: string
//   __isNew__?: boolean
// }

type Form = {
  fullName: string
  email: string | null
  phoneNumber?: {
    code: string
    number: string
  }
  // curricula: SelectOptionType[]
  // teachingLevel: SelectOptionType[]
  // grade: SelectOptionType[]
  // designation: string | null
  // subjects: SelectOptionType[]
}

const FORM_ID = "add-teacher-form"

const initialFormValues: Form = {
  fullName: "",
  email: null,
  // designation: null,
  phoneNumber: {
    code: "",
    number: "",
  },
  // curricula: [],
  // teachingLevel: [],
  // grade: [],
  // subjects: [],
}

// enum CurriculumOptions {
//   CBSE = "CBSE",
//   ICSE_ISC = "ICSE",
//   StateBoardsIndia = "State",
//   InternationalBaccalaureateIB = "IB",
//   CambridgeCAIE = "Cambridge",
//   BritishCurriculum = "British",
//   AmericanCurriculum = "American Curriculum",
// }
// const getCurriculumFromValue = (
//   value: string,
// ): CurriculumOptions | undefined => {
//   return Object.values(CurriculumOptions).find((option) => option === value)
// }

const AddTeacher = ({
  open,
  onClose,
  onSubmit: onSubmitForm,
}: {
  open: boolean
  onClose: () => void
  onSubmit: () => void
}) => {
  // const { subjects, teachingLevels, curriculum, ...props } = useResource([
  //   "subjects",
  //   "teachingLevels",
  //   "curriculum",
  // ])
  const orgId = useClubId()

  const { formState, handleSubmit, register, control, reset } = useForm<Form>({
    defaultValues: initialFormValues,
  })

  const { isSubmitSuccessful, isSubmitting, errors } = formState

  const countryCodeOptions = countryCodes.map(({ dialCode }) => ({
    value: dialCode,
    label: dialCode,
  }))

  // const createNewOption = useCallback(
  //   (item: { name: string; uuid: string }, resource: ResourceOptions) => {
  //     props.createNewOption(item, resource)

  //     switch (resource) {
  //       case "subjects":
  //         {
  //           const currentSubjects = watch("subjects")
  //           const data = currentSubjects.map((i) =>
  //             i.label === item.name ? { ...i, value: item.uuid } : i,
  //           )
  //           setValue("subjects", data)
  //         }

  //         break
  //       case "curriculum":
  //         {
  //           const currentCurricula = watch("curricula")
  //           const data = currentCurricula.map((i) =>
  //             i.label === item.name ? { ...i, value: item.uuid } : i,
  //           )

  //           setValue("curricula", data)
  //         }

  //         break
  //       case "teachingLevels":
  //         {
  //           const currentTeachingLevel = watch("teachingLevel")
  //           const data = currentTeachingLevel.map((i) =>
  //             i.label === item.name ? { ...i, value: item.uuid } : i,
  //           )

  //           setValue("teachingLevel", data)
  //         }

  //         break

  //       default:
  //         break
  //     }
  //   },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [],
  // )

  // const createNewSubject = useMutation({
  //   mutationFn: (data: SelectOptionType) =>
  //     API.global.subjects.create({
  //       data: {
  //         new: [
  //           {
  //             subject: data.label,
  //             userUuid: getAuthInfo()?.user.uuid,
  //           },
  //         ],
  //       },
  //     }),
  //   onSuccess(data) {
  //     if (data && data.length > 0 && data[0]) {
  //       createNewOption(
  //         {
  //           name: data[0].name,
  //           uuid: data[0].uuid,
  //         },
  //         "subjects",
  //       )
  //     }
  //   },
  //   onError(error) {
  //     mapErrors(error)
  //   },
  // })

  // const createNewCurricula = useMutation({
  //   mutationFn: (data: SelectOptionType) =>
  //     API.global.curricula.create({
  //       data: {
  //         new: [
  //           {
  //             curriculum: data.label,
  //             userUuid: getAuthInfo()?.user.uuid,
  //           },
  //         ],
  //       },
  //     }),
  //   onSuccess(data) {
  //     if (data && data.length > 0 && data[0]) {
  //       createNewOption(
  //         {
  //           name: data[0].name,
  //           uuid: data[0].uuid,
  //         },
  //         "curriculum",
  //       )
  //     }
  //   },
  //   onError(error) {
  //     mapErrors(error)
  //   },
  // })

  // const createNewTeachingLevels = useMutation({
  //   mutationFn: (data: SelectOptionType) =>
  //     API.global.teachingLevels.create({
  //       data: {
  //         new: [
  //           {
  //             teaching_level: data.label,
  //             userUuid: getAuthInfo()?.user.uuid,
  //           },
  //         ],
  //       },
  //     }),
  //   onSuccess(data) {
  //     if (data && data.length > 0 && data[0]) {
  //       createNewOption(
  //         {
  //           name: data[0].name,
  //           uuid: data[0].uuid,
  //         },
  //         "teachingLevels",
  //       )
  //     }
  //   },
  //   onError(error) {
  //     mapErrors(error)
  //   },
  // })

  const addTeacher = useMutation({
    mutationFn: (data: Form) =>
      API.teachers.addTeacher({
        data: {
          source: "suraasa_kind",
          name: data.fullName,
          email: data.email,
          ...(data.phoneNumber?.code && data.phoneNumber?.number
            ? { phoneNumber: buildPhoneNumber(data.phoneNumber) }
            : {}),
          // subjectsTaught: data.subjects.map((i) => ({
          //   name: i.label,
          //   uuid: i.value,
          // })),
          // gradesTaught: data.grade.map((i) => i.value),
          // curricula: data.curricula.map((i) => ({
          //   name: i.label,
          //   uuid: i.value,
          // })),
          // teachingLevels: data.teachingLevel.map((i) => ({
          //   name: i.label,
          //   uuid: i.value,
          // })),
          organization: orgId,
          // ...(data.designation ? { designation: data.designation } : {}),
          // TODO: Ask What is this
          //   department: "",
        },
      }),
    onSuccess() {
      onSubmitForm()
    },
    onError(error) {
      mapErrors(error)
    },
  })

  // const createOption = (value: SelectOptionType, resource: ResourceOptions) => {
  //   switch (resource) {
  //     case "subjects":
  //       createNewSubject.mutate(value)
  //       break
  //     case "curriculum":
  //       createNewCurricula.mutate(value)
  //       break
  //     case "teachingLevels":
  //       createNewTeachingLevels.mutate(value)
  //       break

  //     default:
  //       break
  //   }
  // }

  useEffect(() => {
    if (!open) {
      reset({})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const onSubmit = handleSubmit(async (data) => {
    await addTeacher.mutateAsync(data)
  })
  // const currentBoard = watch("curricula")

  // const gradeOptions = useMemo(() => {
  //   if (!currentBoard || currentBoard.length === 0 || currentBoard.length > 1) {
  //     return allGrades
  //   }

  //   const curriculum = getCurriculumFromValue(currentBoard[0].label)

  //   if (!curriculum) {
  //     return allGrades
  //   }

  //   switch (curriculum) {
  //     case CurriculumOptions.CBSE:
  //     case CurriculumOptions.ICSE_ISC:
  //     case CurriculumOptions.StateBoardsIndia:
  //       return defaultGrades
  //     case CurriculumOptions.InternationalBaccalaureateIB:
  //       return gradeOptionsForIB
  //     case CurriculumOptions.CambridgeCAIE:
  //       return gradeOptionsForCambridge
  //     case CurriculumOptions.BritishCurriculum:
  //       return gradeOptionsForBritishCurriculum
  //     case CurriculumOptions.AmericanCurriculum:
  //       return americanCurriculum
  //     default:
  //       return allGrades
  //   }
  // }, [currentBoard])

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-xl">
        <DialogHeader className="!border-0">
          <DialogTitle>
            <Typography variant="title3">Add a Teacher</Typography>
          </DialogTitle>
        </DialogHeader>
        <DialogBody className="p-2.5">
          <div>
            <AnimatePresence mode="wait">
              {isSubmitSuccessful && (
                <motion.div
                  key="success"
                  {...transitionVariants}
                  className="mt-2"
                >
                  <SuccessFormSubmit title="Teacher is added successfully" />
                </motion.div>
              )}

              {!isSubmitSuccessful && (
                <motion.form
                  key="form"
                  onSubmit={onSubmit}
                  id={FORM_ID}
                  className="flex flex-col gap-2 pb-0.5"
                  // {...transitionVariants}
                >
                  <Typography className="mb-1 max-w-[380px] text-onSurface-500">
                    Enter the teacher’s details to add them to your school’s
                    directory.
                  </Typography>
                  <TextField
                    required
                    errors={errors.fullName?.message}
                    placeholder="Enter Full Name"
                    label="Full Name"
                    {...register("fullName", {
                      required: { value: true, message: "Required" },
                    })}
                  />
                  <TextField
                    required
                    type="email"
                    errors={errors.email?.message}
                    label="Email Address"
                    placeholder="Enter your email address"
                    {...register("email", {
                      required: { value: true, message: "Required" },
                    })}
                  />
                  <Controller
                    control={control}
                    name="phoneNumber"
                    render={({ field: { value, onChange } }) => {
                      return (
                        <SplitTextField
                          selectProps={{
                            placeholder: "+91",
                            inputMode: "numeric",
                            maxMenuHeight: 200,
                            mountOnBody: true,
                            value: countryCodeOptions.find(
                              (c) => c.value === value?.code,
                            ),
                            onChange: (val) => {
                              if (val?.value)
                                onChange({ ...value, code: val?.value })
                            },
                            options: countryCodeOptions,
                          }}
                          className="[&>_input]:no-spinner"
                          textFieldProps={{
                            placeholder: "Phone Number",
                            type: "number",
                            value: value?.number ?? undefined,
                            onChange: (e) => {
                              onChange({ ...value, number: e.target.value })
                            },
                          }}
                          helperText={errors.phoneNumber?.message}
                          error={Boolean(errors.phoneNumber)}
                          label="Phone Number (optional)"
                          fullWidth
                        />
                      )
                    }}
                    // rules={{
                    //   validate: (v) => {
                    //     if (!v) return "Required"
                    //     if (!v.code) return "Country code is required"
                    //     if (!v.number) return "Phone Number is required"
                    //   },
                    // }}
                  />

                  {/* <Controller
                    control={control}
                    name="curricula"
                    render={({ field: { value, onChange, onBlur } }) => (
                      <CreatableSelect
                        required
                        errors={errors.curricula?.message}
                        label="Board"
                        options={curriculum.map((i) => ({
                          label: i.name,
                          value: i.uuid,
                        }))}
                        placeholder="Select Board"
                        mountOnBody
                        isMulti
                        onBlur={onBlur}
                        isClearable
                        isLoading={createNewSubject.isPending}
                        value={value}
                        onChange={(val, actionMeta) => {
                          const newVal = val.find((i) => "__isNew__" in i) as
                            | SelectOptionType
                            | undefined

                          if (actionMeta.action === "create-option" && newVal) {
                            createOption(newVal, "curriculum")
                          }
                          onChange(val || [])
                        }}
                      />
                    )}
                    rules={{
                      required: { value: true, message: "Required" },
                    }}
                  />
                  <Controller
                    control={control}
                    name="teachingLevel"
                    render={({ field: { value, onChange, onBlur } }) => (
                      <CreatableSelect
                        isMulti
                        isClearable
                        required
                        errors={errors.teachingLevel?.message}
                        label="Teaching Level"
                        options={teachingLevels.map((i) => ({
                          label: i.name,
                          value: i.uuid,
                        }))}
                        placeholder="Select Teaching Level"
                        mountOnBody
                        onBlur={onBlur}
                        isLoading={createNewSubject.isPending}
                        value={value}
                        onChange={(val, actionMeta) => {
                          const newVal = val.find((i) => "__isNew__" in i) as
                            | SelectOptionType
                            | undefined

                          if (actionMeta.action === "create-option" && newVal) {
                            createOption(newVal, "teachingLevels")
                          }
                          onChange(val || [])
                        }}
                      />
                    )}
                    rules={{
                      required: { value: true, message: "Required" },
                    }}
                  />
                  <Controller
                    control={control}
                    name="grade"
                    render={({ field: { value, onChange, onBlur } }) => (
                      <CreatableSelect
                        isMulti
                        isClearable
                        required
                        errors={errors.grade?.message}
                        label="Grade"
                        options={gradeOptions.map((o) => ({
                          label: o,
                          value: o,
                        }))}
                        placeholder="Select Grade"
                        mountOnBody
                        onBlur={onBlur}
                        value={value}
                        onChange={(val) => onChange(val)}
                      />
                    )}
                    rules={{
                      required: { value: true, message: "Required" },
                    }}
                  />
                  <TextField
                    errors={errors.designation?.message}
                    label="Designation (Optional)"
                    placeholder="Enter Designation"
                    {...register("designation")}
                  />
                  <Controller
                    control={control}
                    name="subjects"
                    render={({ field: { value, onChange, onBlur } }) => (
                      <CreatableSelect
                        required
                        errors={errors.subjects?.message}
                        label="Subjects"
                        options={subjects.map((o) => ({
                          label: o.name,
                          value: o.uuid,
                        }))}
                        placeholder="Select Subjects"
                        mountOnBody
                        onBlur={onBlur}
                        menuPlacement="top"
                        isClearable
                        isMulti
                        isLoading={createNewSubject.isPending}
                        value={value}
                        onChange={(val, actionMeta) => {
                          const newVal = val.find((i) => "__isNew__" in i) as
                            | SelectOptionType
                            | undefined

                          if (actionMeta.action === "create-option" && newVal) {
                            createOption(newVal, "subjects")
                          } else {
                            // console.log("ABBA - select", val)
                            // onChange(val || [])
                          }
                          // console.log("ABBA - select", val)
                          onChange(val || [])
                          // onChange(val || [])
                        }}
                      />
                    )}
                    rules={{
                      required: { value: true, message: "Required" },
                    }}
                  /> */}
                </motion.form>
              )}
            </AnimatePresence>
          </div>
        </DialogBody>
        <DialogFooter
          className={clsx({ "border-transparent": isSubmitSuccessful })}
        >
          {!isSubmitSuccessful && (
            <Button
              size="sm"
              loading={isSubmitting}
              color="black"
              type="submit"
              form={FORM_ID}
            >
              Add Teacher
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default AddTeacher
